import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { Chip, MenuItem, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useEffect, useState } from 'react';
import '../ticketKnowledge/DrilldownAndDetailSearch.css';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { I18n } from 'aws-amplify';
import _ from 'lodash';
import AlertSettingPermission from './AlertSettingPermission';
import { handleUpdateChatPermissionOptionList } from '../ticketList/handler/SettingPermissionHandler';

export default function SettingViewPermissionForm({ props, argsAll }) {
    const [viewPermissionList, setViewPermissionList] = useState([]);
    const [isAlertOpen, setIsAlertOpen] = useState(false);

    const knowledgeTicketViewPermissions = Constant.KNOWLEDGE_TICKET_VIEW_PERMISSION_TEXT;

    const onChangeSelectedViewPermission = (_, value) => {
        argsAll.setSelectedViewPermissions(value);
        handleUpdateChatPermissionOptionList(argsAll,value);
        argsAll.setIsViewPermissionSelected(true);
        if (value.length > 0) {
            argsAll.setIsChangeData(true);
        } else {
            argsAll.setIsChangeData(false);
        }
    };

    const filterSugguestionViewOption = createFilterOptions({
        ignoreCase: false,
        stringify: option => `${option}`
    });

    const handleDeleteViewPermission = selectedOption => {
        let newSelectViewPermissions = argsAll.selectedViewPermissions.filter(option => {
            return option !== selectedOption;
        });
        argsAll.setSelectedViewPermissions([...newSelectViewPermissions]);
        handleUpdateChatPermissionOptionList(argsAll, [...newSelectViewPermissions]);
        argsAll.setIsViewPermissionSelected(true);
        if (argsAll.formEdit) argsAll.setIsChangeData(true);
        if (newSelectViewPermissions.length === 0) argsAll.setIsChangeData(false);
    };

    useEffect(() => {
        const optionViewPermissionList = Object.keys(knowledgeTicketViewPermissions)?.map(
            key => knowledgeTicketViewPermissions[key]
        );
        setViewPermissionList(optionViewPermissionList);

        if (argsAll.formEdit) {
            const selectedViewPermissions = argsAll.formEdit.viewPermission?.map(
                key => knowledgeTicketViewPermissions[key]
            );
            if (Utils.isEmptyArray(selectedViewPermissions)) {
                argsAll.setSelectedViewPermissions([]);
                handleUpdateChatPermissionOptionList(argsAll, [])
            } else {
                argsAll.setSelectedViewPermissions([...selectedViewPermissions]);
                handleUpdateChatPermissionOptionList(argsAll, [...selectedViewPermissions])
            }
        }
    }, []);

    return (
        <>
            <div className="lstCreateForm padding-0">
                <label className="share-option-text">基本閲覧権限</label>
                <div className="share-option-control">
                    <Autocomplete    
                        className="search-option-tag-content"
                        multiple
                        filterSelectedOptions
                        filterOptions={filterSugguestionViewOption}
                        getOptionLabel={option => option}
                        options={viewPermissionList}
                        value={argsAll.selectedViewPermissions}
                        onChange={onChangeSelectedViewPermission}
                        disabled={argsAll.isFormReadOnly || (argsAll.isDisplaySettingSynonymSearch(argsAll.corporationDetail, argsAll?.formEdit?.type || argsAll?.addFormType , argsAll.projectDetail) && argsAll.isSynonym)}
                        renderInput={params => (
                            <TextField
                                {...params}
                                variant="outlined"
                                className="form-control"
                                error={argsAll.selectedViewPermissions.length === 0}
                                helperText={
                                    argsAll.selectedViewPermissions.length === 0
                                        ? I18n.get('COMMSG014')
                                        : ''
                                }
                                onKeyDown={event => {
                                    if (event.key === 'Backspace') event.stopPropagation();
                                }}
                            />
                        )}
                        renderTags={valueTag => {
                            return valueTag.map((selecedOption, index) => {
                                return argsAll.isFormReadOnly ||
                                    [
                                        Constant.KNOWLEDGE_TICKET_VIEW_PERMISSION_TEXT.CREATOR,
                                        Constant.KNOWLEDGE_TICKET_VIEW_PERMISSION_TEXT.IN_PROJECT
                                    ].includes(selecedOption) ? (
                                    <Chip
                                        label={selecedOption}
                                        className="MuiChip-root setting-title"
                                        deleteIcon={true}
                                    />
                                ) : (
                                    <Chip
                                        label={selecedOption}
                                        className="MuiChip-root setting-title"
                                        onDelete={e => {
                                            valueTag.length > 1
                                                ? handleDeleteViewPermission(selecedOption)
                                                : setIsAlertOpen(true);
                                        }}
                                    />
                                );
                            });
                        }}
                        ListboxProps={{
                            style: {
                                maxHeight: 376,
                                overflow: 'auto',
                                overflowX: 'hidden'
                            }
                        }}
                        noOptionsText={I18n.get('COMMSG001')}
                    />
                    <AlertSettingPermission isOpen={isAlertOpen} setIsOpen={setIsAlertOpen} />
                </div>
            </div>
        </>
    );
}
